import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BOMItem } from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class MaterialBomFormService {
  public constructor(private readonly fb: UntypedFormBuilder) {}

  public createFormGroup(isBomLocked: boolean, bomItem?: BOMItem): UntypedFormGroup {
    /* eslint-disable @typescript-eslint/unbound-method */
    return this.fb.group({
      component: [bomItem?.component, [Validators.required]],
      engineeringChangeOrderNumber: ['', isBomLocked ? [Validators.required] : []],
      id: [bomItem?.id],
      itemCategory: [bomItem?.itemCategory ?? 'L'],
      sortString: [bomItem?.sortString],
      unit: [bomItem?.unit ?? 'KG'],
      weight: [bomItem?.weight, [Validators.required]],
    });
    /* eslint-enable @typescript-eslint/unbound-method */
  }

  public adaptToDomain(formGroup: UntypedFormGroup): Partial<BOMItem> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values = formGroup.value;

    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
    return {
      component: values.component || undefined,
      engineeringChangeOrderNumber: values.engineeringChangeOrderNumber || undefined,
      id: values.id || undefined,
      itemCategory: values.itemCategory || 'L',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      sortString: values.sortString?.toString() || undefined, // || is deliberate do not change!
      unit: values.unit || 'KG',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      weight: values.weight?.toString() ?? undefined,
    };
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
  }
}
